/* tslint:disable */
/* eslint-disable */
/**
 * Ampersand public API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IntegrationObject } from './IntegrationObject';
import {
    IntegrationObjectFromJSON,
    IntegrationObjectFromJSONTyped,
    IntegrationObjectToJSON,
} from './IntegrationObject';

/**
 * 
 * @export
 * @interface IntegrationRead
 */
export interface IntegrationRead {
    /**
     * 
     * @type {Array<IntegrationObject>}
     * @memberof IntegrationRead
     */
    objects?: Array<IntegrationObject>;
}

/**
 * Check if a given object implements the IntegrationRead interface.
 */
export function instanceOfIntegrationRead(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function IntegrationReadFromJSON(json: any): IntegrationRead {
    return IntegrationReadFromJSONTyped(json, false);
}

export function IntegrationReadFromJSONTyped(json: any, ignoreDiscriminator: boolean): IntegrationRead {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'objects': !exists(json, 'objects') ? undefined : ((json['objects'] as Array<any>).map(IntegrationObjectFromJSON)),
    };
}

export function IntegrationReadToJSON(value?: IntegrationRead | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'objects': value.objects === undefined ? undefined : ((value.objects as Array<any>).map(IntegrationObjectToJSON)),
    };
}

